<template>
    <v-card :id="`venda_${item.id_pedido}`" class="v-card-venda  my-2 rounded-2 " style="position:relative">
        <basic-info-row
                :valor-bem="item.valor_bem"
                :cd-comissionado="item.cd_comissionado"
                :nm-comissionado="item.nm_comissionado"
                :cd-ponto-venda="item.cd_ponto_venda"
                :quantidade-cotas="getQTCotas(item.carrinho)"
                :nm-ponto-venda="item.nm_ponto_venda"
        />

        <v-row no-gutters class="background--grey pt-7 pb-6">
            <v-col cols="12" sm="6" md="3" class="d-flex flex-grow-1 divisao">
                <PropostaInfoColumn
                        :nome="getNomeCliente(item)"
                        :documento="getDocumentoCliente(item)"
                        :tipo-documento="getTipoDocumentoCliente(item)"
                        :proposta="item.id_documento || 'Não gerada'"
                        :id-reserva="item.id_reserva"
                        :data-venda="item.data_criacao_pedido"
                        :data-final="getDataVendaFinal(item)"
                        :nome-flavor="trazerNomeFlavorPorIdFlavor(item.id_flavor_utilizado_na_venda)"
                        :nome-empresa="trazerAdministradoraPorEmpresa(item.id_empresa_venda_logada)"
                        :tipo-grupo-icon="getTipoGrupoIcon()"
                        :tipo-grupo="getTipoGrupoText()"
                        :quantidade-cotas="getQTCotas(item.carrinho)"
                        :multiplas-reservas="getMultiplasReserva(item.carrinho)"
                        :id-carrinho="item.id_carrinho"
                ></PropostaInfoColumn>
            </v-col>

            <!-- Segunda Coluna: Informações Bem -->
            <v-col v-show="!processoAtivo" cols="12" sm="12" md="6" class="d-flex flex-grow-1 divisao order-last order-md-1 ">
                <ProdutoColumn v-show="!processoAtivo"
                               :product-name="getNomeProduto(item.nome_produto)"
                               :product-icon="getIcon(item.id_produto)"
                               :bem-text="getTextoBem(item)"
                               :plano-text="getTextoPlano(item)"
                               :grupo="item.cd_grupo || '-'"
                               :pz-comercializacao="item.pz_comercializacao || '-'"
                               :id-carrinho="item.id_carrinho"
                               :show-expiracao-banner="showExpiracaoBanner"
                               :pedidos="item.carrinho ? item.carrinho.pedidos || [] : [item]"
                               :carrinho="item.carrinho"
                />
            </v-col>

            <!-- Terceira Coluna: Ação -->
            <v-col v-show="!processoAtivo || this.$vuetify.breakpoint.smAndDown" cols="12" sm="6" md="3" class="d-flex flex-grow-1 divisao-no-border order-md-2">
                <ActionColumn v-show="!processoAtivo || this.$vuetify.breakpoint.smAndDown"
                              @acaoDetalhes="acaoDetalhes"
                              @acaoExpiracaoReservas="acaoExpiracaoReservas"
                              :quantidade-cotas="item.carrinho && item.carrinho.qt_cotas"
                              :carrinho="item.carrinho"
                />
            </v-col>
            <v-col v-if="processoAtivo" cols="12" md="9" class="containerLinhaDoTempo">
                <LinhaDoTempoDaProposta @fecharProcessoDetalhado="fecharProcessoDetalhado" :ativo="statusAtivo" :processo="processoAtivo" :numero-da-cota="item.cd_cota" />
            </v-col>
        </v-row>
        <v-row no-gutters class="background--grey">
            <v-col cols="12" md="3"><CardStatus :processo-ativo="processoAtivo" @ativaExibicaoStatus="ativaExibicaoStatus" :style="{ borderRadius: $vuetify.breakpoint.smAndDown ? '0px 0px 0px 0px' : '0px 0px 0px 8px'}" :processo="ProcessosDeVenda.statusPedido" :status="statusVenda" :icon-classes="statusVendaEstilos.icon" :bar-color="statusVendaEstilos.color" :updated-at="dataAtualizacaoVenda" texto-atualizacao="Atualizada" /></v-col>
            <v-col cols="12" md="3"><CardStatus :processo-ativo="processoAtivo" @ativaExibicaoStatus="ativaExibicaoStatus" :processo="ProcessosDeVenda.statusCredito" :status="statusAnaliseCadastral" :icon-classes="statusAnaliseCadastralEstilos.icon" :bar-color="statusAnaliseCadastralEstilos.color" :updated-at="dataAtualizacaoAnaliseCadastral" /></v-col>
            <v-col cols="12" md="3"><CardStatus :processo-ativo="processoAtivo" @ativaExibicaoStatus="ativaExibicaoStatus" :processo="ProcessosDeVenda.statusPagamento" :status="statusPagamento" :icon-classes="statusPagamentoEstilos.icon" :bar-color="statusPagamentoEstilos.color" :updated-at="dataAtualizacaoVenda" /></v-col>
            <v-col cols="12" md="3"><CardStatus :processo-ativo="processoAtivo" @ativaExibicaoStatus="ativaExibicaoStatus" :style="{ borderRadius: $vuetify.breakpoint.smAndDown ? '0px 0px 0px 8px' : '0px 0px 8px 0px'}" :processo="ProcessosDeVenda.statusContrato" :status="statusContrato" :icon-classes="statusContratoEstilos.icon" :bar-color="statusContratoEstilos.color" :updated-at="dataAtualizacaoContrato" /></v-col>
        </v-row>
    </v-card>
</template>
<script>
  import editarVendasMixin from '../../mixins/editarVendasMixin'
  import { IconesPorProduto } from '../../plugins/iconsProdutosById'
  import { getDescricaoStatusContrato, getStatusContrato, isVendaNaoGerada } from '../../plugins/helpers'
  import { TipoPessoa, StatusPagamentosPagos, ListaAgrupamentosDeStatusPagamento, ListaAgrupamentosDeStatusPagamentoPrioridade, StatusVendaNaoGerada } from '@/plugins/constants'
  import { ListaStatusContrato } from '../../plugins/listaStatusStyles'
  import { getStatusAnaliseCadastral, getEstilosAnaliseCadastral } from '../../helpers/analise_credito_helpers'
  import BasicInfoRow from './fragments/BasicInfoRow.vue'
  import LinhaDoTempoDaProposta from './fragments/LinhaDoTempoDaProposta.vue'
  import PropostaInfoColumn from './fragments/PropostaInfoColumn.vue'
  import ActionColumn from './fragments/ActionColumn.vue'
  import ProdutoColumn from './fragments/ProdutoColumn.vue'
  import { ListaAgrupamentosDeStatusContratoPrioridade, ListaAgrupamentosDeStatusPedidoPrioridade, StatusPedidoDesc, TiposGrupoIndividualText } from '../../plugins/constants'
  import CardStatus from './fragments/CardStatus.vue'
  import { estilosStatusAnaliseCadastralPorStatus, estilosStatusContratoPorNomeExibicao, estilosStatusPedidoPorNomeExibicao, estilosStatusPagamentoPorStatus } from '../../plugins/listaEstilosPorStatusPorNomeExibicao'
  import { ProcessosDeVenda } from '../../plugins/processosDeVenda'

  export default {
    name: 'CardVenda',
    components: { BasicInfoRow, PropostaInfoColumn, ActionColumn, ProdutoColumn, CardStatus, LinhaDoTempoDaProposta },
    mixins: [editarVendasMixin],
    props: {
      item: {
        type: Object,
        required: true
      },
      administradoras: {
        type: Array,
        required: true
      },
      flavorsEEmpresasProp: {
        type: Array,
        required: true,
        default: () => []
      },
      flavorsProp: {
        type: Array,
        required: true,
        default: () => []
      },
      filtroProcessoVenda: {
        type: String,
        default: ''
      },
      filtroProcessoAnaliseCredito: {
        type: String,
        default: ''
      },
      filtroProcessoPagamento: {
        type: String,
        default: ''
      },
      filtroProcessoContrato: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        ProcessosDeVenda,
        statusAtivo: '',
        processoAtivo: ''
      }
    },
    computed: {
      possuiFiltrosProcessoAtivos () {
        return this.filtroProcessoVenda || this.filtroProcessoAnaliseCredito ||
          this.filtroProcessoPagamento || this.filtroProcessoContrato
      },
      showExpiracaoBanner () {
        if (!this.item.carrinho || !this.item.carrinho.pedidos || !this.item.carrinho.pedidos.length || !isVendaNaoGerada(this.item.status_pedido)) {
          return false
        }
        return this.item.carrinho.pedidos.some(pedido => pedido.id_reserva)
      },
      pedidoStatusVendaMaisCritica () {
        if (!this.item.carrinho || !this.item.carrinho.pedidos) {
          return this.item
        }

        let pedidosParaAvaliar = this.item.carrinho.pedidos

        if (this.filtroProcessoVenda && this.possuiFiltrosProcessoAtivos) {
          pedidosParaAvaliar = pedidosParaAvaliar.filter(pedido =>
            this.pedidoCorrespondeAoFiltroProcessoVenda(pedido, this.filtroProcessoVenda)
          )
        }

        if (pedidosParaAvaliar.length === 0) {
          pedidosParaAvaliar = this.item.carrinho.pedidos
        }

        let statusMaisCritico = null
        let pedidoMaisCritico = null
        pedidosParaAvaliar.forEach(pedido => {
          const statusAgrupado = StatusPedidoDesc[pedido.status_pedido]
          if (statusAgrupado) {
            if (!statusMaisCritico || ListaAgrupamentosDeStatusPedidoPrioridade[statusAgrupado] < ListaAgrupamentosDeStatusPedidoPrioridade[statusMaisCritico]) {
              statusMaisCritico = statusAgrupado
              pedidoMaisCritico = pedido
            }
          }
        })
        return pedidoMaisCritico
      },
      statusVenda () {
        return StatusPedidoDesc[this.pedidoStatusVendaMaisCritica.status_pedido] ?? ''
      },
      dataAtualizacaoVenda () {
        return this.pedidoStatusContratoMaisCritico.updated_at
      },
      statusVendaEstilos () {
        return estilosStatusPedidoPorNomeExibicao[this.statusVenda] ?? ''
      },
      pedidoStatusContratoMaisCritico () {
        if (!this.item.carrinho || !this.item.carrinho.pedidos) {
          return this.item
        }

        let pedidosParaAvaliar = this.item.carrinho.pedidos

        if (this.filtroProcessoContrato && this.possuiFiltrosProcessoAtivos) {
          pedidosParaAvaliar = pedidosParaAvaliar.filter(pedido =>
            this.pedidoCorrespondeAoFiltroProcessoContrato(pedido, this.filtroProcessoContrato)
          )
        }

        if (pedidosParaAvaliar.length === 0) {
          pedidosParaAvaliar = this.item.carrinho.pedidos
        }

        let statusMaisCritico = null
        let propostaMaisCritica = null
        pedidosParaAvaliar.forEach(pedido => {
          const statusAgrupado = getDescricaoStatusContrato(pedido?.contrato?.status, pedido.docusign_falha, pedido.docusign_enviado) ?? ''
          if (statusAgrupado) {
            if (!statusMaisCritico || ListaAgrupamentosDeStatusContratoPrioridade[statusAgrupado] < ListaAgrupamentosDeStatusContratoPrioridade[statusMaisCritico]) {
              statusMaisCritico = statusAgrupado
              propostaMaisCritica = pedido
            }
          }
        })
        return propostaMaisCritica
      },
      statusContrato () {
        if (!this.item.carrinho || !this.item.carrinho.pedidos) {
          return getDescricaoStatusContrato(this.pedidoStatusContratoMaisCritico.status, this.pedidoStatusContratoMaisCritico.docusign_falha, this.pedidoStatusContratoMaisCritico.docusign_enviado) ?? ''
        }
        return getDescricaoStatusContrato(this.pedidoStatusContratoMaisCritico?.contrato?.status, this.pedidoStatusContratoMaisCritico.docusign_falha, this.pedidoStatusContratoMaisCritico.docusign_enviado) ?? ''
      },
      pedidoPossuiCarrinhoGerado () {
        return this.item.carrinho && this.item.carrinho.pedidos
      },
      dataAtualizacaoContrato () {
        if (!this.dataAtualizacaoVenda) {
          return null
        }
        const atualizacao_contrato = this.pedidoPossuiCarrinhoGerado ? this.pedidoStatusContratoMaisCritico?.contrato?.updated_at : this.pedidoStatusContratoMaisCritico.atualizacao_contrato
        if (!atualizacao_contrato) {
          if (this.item.data_venda_final) {
            return this.item.data_venda_final
          }
          return this.item.data_criacao_pedido
        }
        return atualizacao_contrato
      },
      statusContratoEstilos () {
        return estilosStatusContratoPorNomeExibicao[this.statusContrato] ?? ''
      },
      statusAnaliseCadastral () {
        if (!this.item.carrinho || !this.item.carrinho.pedidos || !this.filtroProcessoAnaliseCredito || !this.possuiFiltrosProcessoAtivos) {
          return getStatusAnaliseCadastral(this.item.status_pedido) ?? ''
        }

        const pedidosParaAvaliar = this.item.carrinho.pedidos.filter(pedido =>
          this.pedidoCorrespondeAoFiltroProcessoAnaliseCredito(pedido, this.filtroProcessoAnaliseCredito)
        )

        if (pedidosParaAvaliar.length === 0) {
          return getStatusAnaliseCadastral(this.item.status_pedido) ?? ''
        }

        const pedidoFiltrado = pedidosParaAvaliar[0]
        return getStatusAnaliseCadastral(pedidoFiltrado.status_pedido) ?? ''
      },
      dataAtualizacaoAnaliseCadastral () {
        if (!this.dataAtualizacaoVenda) {
          return null
        }
        const atualizacao_situacao_credito = this.item.atualizacao_situacao_credito
        if (!atualizacao_situacao_credito) {
          return this.item.data_criacao_pedido
        }
        return atualizacao_situacao_credito
      },
      statusAnaliseCadastralEstilos () {
        return estilosStatusAnaliseCadastralPorStatus[this.statusAnaliseCadastral] ?? ''
      },
      statusPagamento () {
        if (!this.item.carrinho || !this.item.carrinho.pedidos) {
          if (this.item.job_carrinho_boleto_falha) {
            return ListaAgrupamentosDeStatusPagamento.Falha
          }
          if (StatusPagamentosPagos.includes(this.item.status_pedido)) {
            return ListaAgrupamentosDeStatusPagamento.Realizado
          }
          if (StatusVendaNaoGerada.includes(this.item.status_pedido)) {
            return ListaAgrupamentosDeStatusPagamento.EmEspera
          }
          return ListaAgrupamentosDeStatusPagamento.Pendente
        }

        let pedidosParaAvaliar = this.item.carrinho.pedidos

        if (this.filtroProcessoPagamento && this.possuiFiltrosProcessoAtivos) {
          pedidosParaAvaliar = pedidosParaAvaliar.filter(pedido =>
            this.pedidoCorrespondeAoFiltroProcessoPagamento(pedido, this.filtroProcessoPagamento)
          )
        }

        if (pedidosParaAvaliar.length === 0) {
          pedidosParaAvaliar = this.item.carrinho.pedidos
        }

        let statusMaisCritico = null

        pedidosParaAvaliar.forEach(pedido => {
          let statusAtual = ListaAgrupamentosDeStatusPagamento.Pendente
          if (pedido.job_carrinho_boleto_falha) {
            statusAtual = ListaAgrupamentosDeStatusPagamento.Falha
          } else if (StatusPagamentosPagos.includes(pedido.status_pedido)) {
            statusAtual = ListaAgrupamentosDeStatusPagamento.Realizado
          } else if (StatusVendaNaoGerada.includes(pedido.status_pedido)) {
            statusAtual = ListaAgrupamentosDeStatusPagamento.EmEspera
          }

          if (!statusMaisCritico || ListaAgrupamentosDeStatusPagamentoPrioridade[statusAtual] < ListaAgrupamentosDeStatusPagamentoPrioridade[statusMaisCritico]) {
            statusMaisCritico = statusAtual
          }
        })

        return statusMaisCritico
      },
      statusPagamentoEstilos () {
        return estilosStatusPagamentoPorStatus[this.statusPagamento]
      }
    },
    mounted () {
      this.flavors = this.flavorsProp
      this.flavorsEEmpresas = this.flavorsEEmpresasProp
    },
    methods: {
      getStatusAnaliseCadastral,
      getEstilosAnaliseCadastral,
      getDescricaoStatusContrato,
      getQTCotas (carrinho) {
        if (carrinho && carrinho.qt_cotas) {
          return carrinho.qt_cotas
        }
        return 1
      },
      getMultiplasReserva (carrinho) {
        return carrinho && carrinho.reserva_com_carrinho
      },
      ativaExibicaoStatus (processoParaAtivar, statusAtivo) {
        this.statusAtivo = statusAtivo
        this.processoAtivo = processoParaAtivar
      },
      fecharProcessoDetalhado () {
        this.statusAtivo = null
        this.processoAtivo = null
      },
      getTipoGrupoIcon () {
        if (this.item.grupo_pontual) {
          return 'mdi-star-outline'
        } else if (this.item.grupo_praja) {
          return 'mdi-clock-fast'
        } else {
          return 'mdi-check-circle-outline'
        }
      },
      getQtCotasCarrinho (item) {
        return item.carrinho && item.carrinho.qt_cotas
      },
      getTipoGrupoText () {
        if (this.item.grupo_pontual) {
          return TiposGrupoIndividualText.GrupoPontual
        } else if (this.item.grupo_praja) {
          return TiposGrupoIndividualText.GrupoPraJa
        } else {
          return TiposGrupoIndividualText.GrupoConvencional
        }
      },
      acaoDetalhes () {
        this.$emit('editar', this.item)
      },
      acaoExpiracaoReservas () {
        this.$emit('expiracaoReservas', this.item)
      },
      vendaEstaComFalhaAlocacao (status_alocacao) {
        if (status_alocacao) {
          return status_alocacao.status_alocacao === 'F'
        }
        return false
      },
      hasNomeCliente (item) {
        let cliente = false
        if (item.cliente && item.cliente.pessoa === TipoPessoa.Juridica) {
          cliente = item.cliente.razao_social
        } else if (item.cliente && item.cliente.pessoa === TipoPessoa.Fisica) {
          cliente = item.cliente.nome_completo
        }
        return cliente || item.nome_cliente || false
      },
      getListaStatusContratoProps (item) {
        const status = getStatusContrato(item.status, item.docusign_falha, item.docusign_enviado)
        return ListaStatusContrato[status]
      },
      getTextoPlano (item) {
        return item.cd_plano_venda ? `${item.cd_plano_venda} - ${item.nome_plano}` : '-'
      },
      getTextoProduto (item) {
        return item.cd_produto ? item.cd_produto : '-'
      },
      getTextoBem (item) {
        return item.cd_bem ? `${item.cd_bem} - ${item.nome_bem}` : '-'
      },
      getDocumentoCliente (item) {
        if (item.cliente && item.cliente.pessoa === TipoPessoa.Juridica) {
          return item.cliente.cnpj
        } else if (item.cliente && item.cliente.pessoa === TipoPessoa.Fisica) {
          return item.cliente.cpf
        }
        return ''
      },
      getNomeCliente (item) {
        let cliente = false
        if (item.cliente && item.cliente.pessoa === TipoPessoa.Juridica) {
          cliente = item.cliente.razao_social
        } else if (item.cliente && item.cliente.pessoa === TipoPessoa.Fisica) {
          cliente = item.cliente.nome_completo
        }
        return cliente || item.nome_cliente || '(Não informado)'
      },
      getTipoDocumentoCliente (item) {
        if (item.cliente && item.cliente.pessoa === TipoPessoa.Juridica) {
          return 'CNPJ:'
        } else if (item.cliente && item.cliente.pessoa === TipoPessoa.Fisica) {
          return 'CPF:'
        }
        return ''
      },
      getComissionado (cd_comissionado, nm_comissionado) {
        let textoComissionado = ''
        if (cd_comissionado) {
          textoComissionado += '' + cd_comissionado
        }
        if (nm_comissionado) {
          textoComissionado += ' - ' + nm_comissionado
        }
        return textoComissionado
      },
      getNomeProduto (nome_produto) {
        if (!nome_produto) {
          nome_produto = '(não informado)'
        }
        return nome_produto
      },
      getIcon (id_produto) {
        let icon = IconesPorProduto[id_produto]

        if (!icon) {
          icon = IconesPorProduto['default']
        }
        return icon
      },
      getDataVendaFinal (item) {
        if (!item.id_documento) {
          return null
        }

        return item.data_venda_final || item.data_venda || null
      },

      pedidoCorrespondeAoFiltroProcessoVenda (pedido, filtro) {
        const statusPedido = StatusPedidoDesc[pedido.status_pedido]
        return this.statusCorrespondeAoFiltro(statusPedido, filtro, 'venda')
      },

      pedidoCorrespondeAoFiltroProcessoAnaliseCredito (pedido, filtro) {
        const statusAnalise = getStatusAnaliseCadastral(pedido.status_pedido)
        return this.statusCorrespondeAoFiltro(statusAnalise, filtro, 'analise_credito')
      },

      pedidoCorrespondeAoFiltroProcessoPagamento (pedido, filtro) {
        let statusPagamento = ListaAgrupamentosDeStatusPagamento.Pendente
        if (pedido.job_carrinho_boleto_falha) {
          statusPagamento = ListaAgrupamentosDeStatusPagamento.Falha
        } else if (StatusPagamentosPagos.includes(pedido.status_pedido)) {
          statusPagamento = ListaAgrupamentosDeStatusPagamento.Realizado
        } else if (StatusVendaNaoGerada.includes(pedido.status_pedido)) {
          statusPagamento = ListaAgrupamentosDeStatusPagamento.EmEspera
        }
        return this.statusCorrespondeAoFiltro(statusPagamento, filtro, 'pagamento')
      },

      pedidoCorrespondeAoFiltroProcessoContrato (pedido, filtro) {
        const statusContrato = getDescricaoStatusContrato(pedido?.contrato?.status, pedido.docusign_falha, pedido.docusign_enviado)
        return this.statusCorrespondeAoFiltro(statusContrato, filtro, 'contrato')
      },

      statusCorrespondeAoFiltro (status, filtro, tipoProcesso) {
        return status === filtro
      }
    }
  }
</script>
<style lang="scss" scoped>
.divisao{
    display: flex;
    flex-direction: column;

    border-right: 1.5px solid var(--gray);
}

.divisao-no-border{
    @extend .divisao;
    border-right: none;
}

.item-list__card-percentage {
    font-size: 1.2rem;
    font-weight: 500;
    color: var(--primary);
}

.containerLinhaDoTempo{
    height: auto;
    width: 100%;
    padding:20px;
    border-radius: 15px;
}
.item-list__card-number {
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--primary);
}
.icon {
    font-size: 2rem;
}
.theme--light.v-data-table .v-data-footer {
    border-top: none;
}
.margin__break_point_sm {
    margin: 10px;
}
@media (max-width: 1300px) {
    .margin__break_point_sm {
        margin: 2px;
    }
}

.rounded-2 {
    border-radius: 10px !important;
}

.margin-top-40 {
    margin-top: 40px;
}

.width-max-100 {
    max-width: 100%;
}

.height-100 {
    height: 100%;
}

.height-90 {
    height: 90%;
}

.basic-info__price--money-signal {
    font-size: 12px;
    margin-right: 2px;
}

.basic-info__proposta {
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 4px;
    max-width: 100%;
}

.basic-infos__proposta--icon {
    margin-bottom: 2px;
    margin-right: 5px;
}

.detailed-info__user-info--text {
    padding-bottom: 10px;
    font-size: 16px;
    line-height: 25px;
    font-weight: 700;
    word-spacing: 1px;
}

.detailed-info__user-info--grey-text {
    font-size: 16px;
    color: #474747d7;
    line-height: 22px;
}

.detailed-info__user-info--grey-little-text {
    font-size: 14px;
    color: #474747d7;
}

.detailed-info__divider {
    width: 220px;
    background-color: #bdbdbdd7;
}

.detailed-info__product-info--text {
    padding-bottom: 10px;
    font-size: 16px;
    line-height: 25px;
    font-weight: 700;
    word-spacing: 1px;
}

.status-info__buttons-box {
    margin-top: 25px;
    margin-bottom: -15px;
}

.status-info__card--button {
    font-size: auto;
    height: 55px !important;
}

.status-info__card {
    width: 100%;
}
.status-info__card--text-box {
    font-size: 18px;
    width: 100%;
}

.status-info__card--status-icon-box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0px 8px 8px 0px;
    margin-right: -3px;
    min-height: 80px;
}

.status-info__card--status-box {
    display: flex;

    align-items: center;
}

.background--grey{
    background-color: var(--darkwhite);
}

.v-card-venda {
  max-width: calc(100% - 40px);
  box-sizing: border-box;
  margin: 20px solid;
  width: 100%;
}
</style>
